import React from "react";
import { useRecoilState } from "recoil";

import {
	FormControl,
	FormLabel,
	FormControlLabel,
	Radio,
	RadioGroup,
} from "@mui/material";

import { VISITOR_AND_SPEND_DAYS, visitorAndSpendOptionsAtom } from './atoms'

export default function TravelTypeSelector() {
	const [visitorAndSpendOptions, setVisitorAndSpendOptions] = useRecoilState(visitorAndSpendOptionsAtom)
  const [selectedDayValue, setSelectedDayValue] = React.useState(visitorAndSpendOptions.day)
  const [timer, setTimer] = React.useState(null)

  const updateDayValue = (e) => {
  	clearTimeout(timer);
  	setSelectedDayValue(e.target.value)
  };

  const afterTimeout = () => {
    setVisitorAndSpendOptions({
      ...visitorAndSpendOptions,
      day: selectedDayValue,
    })
  }

  React.useEffect(() => {
		const t = setTimeout(afterTimeout, 100);
		setTimer(t)
  }, [selectedDayValue])

  const renderRadioButton = (day) => {
  	return (
  		<Radio
  			aria-label={day.label}
  			size="small" />
  	)
  }

	const renderRadioControl = (day) => (
		<FormControlLabel
			key={day.value}
			control={renderRadioButton(day)}
			value={day.value}
			label={day.label}
			sx={{
				width: "180px",
				marginBottom: -1,
			}}/>
	)

	return (
		<FormControl sx={{
			mb: 2,
			ml: 3,
		}}>
			<FormLabel
				id="visitor-and-spend-day-label"
				sx={{
					fontSize: "11px",
					color: '#868b8e',
					marginBottom: '2px',
				}}>
				Day
			</FormLabel>
			<RadioGroup
				row
				name="visitor-and-spend-day-option"
				aria-labelledby="visitor-and-spend-day-label"
				defaultValue={visitorAndSpendOptions.day}
				onChange={updateDayValue}>
				{VISITOR_AND_SPEND_DAYS.map((day) => renderRadioControl(day))}
			</RadioGroup>
		</FormControl>
	)
}